// app/user/user.js

(function () {
    'use strict';
    var controllerId = 'user';
    angular.module('app').controller(controllerId, ['common', 'bootstrap.dialog', '$rootScope', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '$translate', user]);

    function user(common, bDialog, $rootScope, $routeParams, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Utenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        vm.objName = "User"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.risorsa = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !$rootScope.isAuthorized('SUPER');
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.super = $rootScope.isAuthorized('SUPER');

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['username', 'email', 'data attivazione desc'];
        vm.ordine = vm.list.ordine[2];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Elenchi dettaglio
        vm.list.ruoli = [];
        vm.list.gruppoAmm = [];
        vm.list.gruppoDid = [];
        vm.ruoli = [];

        vm.getRecord = getRecord;
        vm.getListRuoli = getListRuoli;
        vm.deleteRuolo = deleteRuolo;
        vm.getRuoli = getRuoli;
        //vm.addRuolo = addRuolo;

        //Filtro
        vm.filter = {};
        vm.filter.bAttivo = 0;
        vm.filter.username = '';
        vm.filter.email = '';
        vm.filter.societaId = 0;
        vm.filter.ruolo = '';

        vm.fUsername;
        vm.fEmail;
        vm.fSocieta;
        vm.fBAttivo = 0;
        vm.fRuolo;

        vm.format = 'dd/MM/yyyy';        

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
        vm.add = addModal;
        vm.addRole = addModalRole;
        vm.update = updateItem;
        vm.updatePassword = updatePassword;
        vm.activate = setActive;
        vm.deactivate = setDeactive;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;
        vm.delete = deleteItem;

        //societa
        vm.societa = [];


        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getSocieta(), getRuoli()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        vm.getRuoli();
                        if ($routeParams.UserId != null) {
                            setView('detail');
                            getRecord($routeParams.UserId, 0);
                        }

                    });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.bAttivo = vm.fBAttivo == null ? 1 : vm.fBAttivo;
            vm.filter.username = vm.fUsername == null ? '' : vm.fUsername;
            vm.filter.email = vm.fEmail == null ? '' : vm.fEmail;
            vm.filter.societaId = vm.fSocieta == null ? 0 : vm.fSocieta;
            vm.filter.ruolo = vm.fRuolo == null ? '' : vm.fRuolo;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.user_countAll(vm.filter.bAttivo, vm.filter.username, vm.filter.email, vm.filter.societaId, vm.filter.ruolo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.user_getAll(vm.pageSize, vm.page, vm.filter.bAttivo, vm.filter.username, vm.filter.email, vm.filter.societaId, vm.filter.ruolo, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;                
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.user_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);

                //Azzera liste
                vm.list.ruoli = [];
                vm.list.gruppoAmm = [];
                vm.list.gruppoDid = [];                

                datacontext.risorsa_getByUsername2(data.Username).then(function (data2) {
                    vm.risorsa = data2;
                });

                vm.record.Password = '';
                vm.confPassword = '';

                getListRuoli(id);
                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.user_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.user_update(vm.record).then(function (data) {
                if (!data) {
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    cerca();
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function updatePassword() {
            if (vm.record.Password != vm.confPassword){
                logError('Le due password devono coincidere');
                return;
            }

            vm.record.DtAttivazione = common.stringToDate(vm.record.DtAttivazione);
            return datacontext.user_update(vm.record).then(function (data) {
                if (!data) {
                    vm.record.DtAttivazione = common.dateToString(vm.record.DtAttivazione);
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        function setActive(id, index) {
            return datacontext.user_activate(id).then(function (data) {
                if (!data) {
                    logSuccess('Dato salvato');
                    cerca();
                }
                else
                    logError('Impossibile salvare il dato');                
            });
        }

        function setDeactive(id) {
            return datacontext.user_deactivate(id).then(function (data) {
                console.dir(data);
                if (!data) {
                    logSuccess('Dato salvato');
                    cerca();
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente pu� inserire una nuova password per il suo account
        function resetPassword(item, index) {
            var msg = ' Inviare Email per il Reset della password all\'utente ' + item.Username;
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
						function () { //YES
						    return datacontext.user_resetPassword(item.Email, item.Lingua).then(function (data) {						        
                                if (data != "204") return logError('Impossibile eseguire l\'operazione');

						        logSuccess('Operazione effettuata con successo');
						        vm.index = index;
						    });
						},
						function () { //NO
						    //vm.record.Completed = false;
						});
        }

        function invioCredenziali(item, index) {
            var msg = ' Inviare Email con le Nuove Credenziali dell\'utente ' + item.Username;
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
						function () { //YES
						    return datacontext.user_invioCredenziali(item.Email, item.Lingua).then(function (data) {						        
						        if (data != "204") return logError('Impossibile eseguire l\'operazione');

						        logSuccess('Operazione effettuata con successo');
						        vm.index = index;
						    });
						},
						function () { //NO
						    //
						});
        }

        function deleteItem(item) {
            var msg = ' l\'utente ' + item.Username;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.user_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Elenchi dettagli
        function getRuoli() {
            return datacontext.role_getAll().then(function (data) {
                return vm.ruoli = data;
            });
        }

        function getListRuoli(id) {
            return datacontext.userRole_getAll(id).then(function (data) {
                return vm.list.ruoli = data;
            });
        }        

        function deleteRuolo(item) {
            var msg = ' Ruolo ' + item.Etichetta + ' per l utente ' + vm.record.Username;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.userRole_delete(vm.record.Id, item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.list.ruoli.indexOf(item)
                    vm.list.ruoli.splice(index, 1);
                });
            });
        }        

        //Elenco Parametri
        function getSocieta() {
            return datacontext.societa_getAllList().then(function (data) {
                return vm.societa = data;
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            console.log('addModal');
            var record = { Id: vm.record.Id, Name: vm.record.Username };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/user/modal/userAdd.html?version=43',
                controller: 'userAdd',
                resolve: {
                    societa: function () {
                        return vm.societa;
                    },
                    societaId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getListRuoli(vm.record.Id);
            });
        };

        function addModalRole() {
            console.log('addModalRole');
            var record = { Id: vm.record.Id, Name: vm.record.Username };

            //Ruolo
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/user/modal/userRoleAdd.html?version=43',
                controller: 'userRoleAdd',
                resolve: {
                    risorse: function () {
                        return [record];
                    },
                    risorsaId: function () {
                        return vm.record.Id;
                    },
                    ruoli: function () {
                        return vm.ruoli;
                    },
                    ruoloId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                getListRuoli(vm.record.Id);
            });
        };
    }
})();
